<template>
	<div class="detail">
		<a :href="job.skipUrl">
			<div class="content" @click="mixPanelLog('list')">
				<div class="img-box">
					<img class="img-map" :src="job.mapUrl | mapImgUrl" :onerror="defaultImg" @click.stop="mixPanelLog('img')" />
					<div v-if="job.channel === 'ZipRecruiter'" class="bg-zipRecruiter"></div>
				</div>

				<h2>{{ job.title }}</h2>
				<div class="tags">
					<span v-if="job.tagOne">{{ job.tagOne }}</span>
					<span v-if="job.tagTwo">{{ job.tagTwo }}</span>
					<span v-if="job.tagThree">{{ job.tagThree }}</span>
				</div>
				<div class="bottom">
					<div class="company-info">
						<img class="company-logo" :src="icons[0].src" :alt="icons[0].alt" />
						<span class="company-name">{{ job.company }}</span>
					</div>
					<div class="apply-job">
						<el-button type="primary" class="button" @click.stop="appJob">
							Apply Now
						</el-button>
					</div>
				</div>
			</div>
		</a>
	</div>
</template>

<script>
import mixpanel from '@/utils/mixpanel.js'

export default {
	props: {
		job: {
			type: Object,
			default: () => {}
		},
		applyNow: {
			type: Boolean,
			default: false
		},
		source: {
			type: String,
			default: ''
		},
		width: {
			type: [String, Number],
			default: 686
		},
		height: {
			type: [String, Number],
			default: 517
		}
	},
	data() {
		return {
			loading: false,
			defaultImg: 'this.src="' + require('@/assets/images/jobBoard/job-map-default.jpg') + '"',
			icons: [
				{
					src: require('@/assets/icon/img_company.svg'),
					alt: 'img_company'
				},
				{
					src: require('@/assets/icon/ic_map.svg'),
					alt: 'ic-map'
				}
			]
		}
	},
	methods: {
		appJob() {
			this.mixPanelLog('jobBtn')
		},
		mixPanelLog(type) {
			const job = this.job

			if (type === 'img') {
				mixpanel.track('Job Board Page', {
					Job: job.jobId,
					Outcome: 'Click on job map img'
				})
			}

			if (type === 'list') {
				mixpanel.track('Job Board Page', {
					Job: job.jobId,
					Outcome: 'Click on job list'
				})
			}

			if (type === 'jobBtn') {
				mixpanel.track('Job Board Page', {
					Job: job.jobId,
					Outcome: 'Click on Apply on job list'
				})
			}
		}
	},
	filters: {
		mapImgUrl(url) {
			if (!url) return require('@/assets/images/jobBoard/job-map-default.jpg')
			return url
		}
	}
}
</script>

<style lang="scss" scoped>
@import '@/scss/rem.scss';

.detail {
	display: flex;
	justify-content: center;
	position: relative;
	width: 100%;
	padding: 0 rem-base-50(15px) 0 rem-base-50(15px);
	margin-top: rem-base-50(15px);

	.content {
		background-color: #fff;
		padding-top: rem-base-50(5px);
		margin-bottom: rem-base-50(2px);
		width: rem-base-50(345px);
		position: relative;
		display: flex;
		flex-direction: column;
		border-radius: rem-base-50(4px);
		border: solid 1px #e7ebf3;
		overflow: hidden;

		.img-box {
			width: rem-base-50(335px);
			height: rem-base-50(168px);
			margin: 0 auto;
			margin-bottom: rem-base-50(10px);
			position: relative;
		}

		.img-map {
			width: 100%;
			height: 100%;
			cursor: pointer;
		}

		.bg-zipRecruiter {
			display: flex;
			justify-content: center;
			align-items: center;
			position: absolute;
			top: rem-base-50(-5px);
			right: rem-base-50(0px);
			width: rem-base-50(117px);
			height: rem-base-50(24px);
			background: url('../../../assets/images/jobBoard/icon-trapezium.png') center/100% no-repeat;
		}

		& > h2 {
			font-family: SFProText-Bold;
			font-size: rem-base-50(16px);
			color: #141a42;
			font-weight: bold;
			letter-spacing: 0;
			margin-left: rem-base-50(10px);
		}

		.tags {
			margin-top: rem-base-50(10px);
			margin-left: rem-base-50(10px);
			display: flex;
			& > span {
				display: inline-block;
				font-family: SFProText-Regular;
				color: #141a42;
				padding: 0 rem-base-50(10px);
				font-size: rem-base-50(12px);
				border-radius: rem-base-50(2px);
				margin-right: rem-base-50(8px);
				padding: rem-base-50(4px);
				border: none;
				background-color: rgb(246, 247, 250);
			}
		}

		.bottom {
			display: flex;
			align-items: center;
			width: 100%;
			margin: rem-base-50(9px) rem-base-50(10px) rem-base-50(15px) rem-base-50(10px);
			.company-info {
				display: flex;
				align-items: center;
				flex: 1;
				.company-logo {
					width: rem-base-50(40px) !important;
					height: rem-base-50(30px) !important;
				}
				.company-name {
					margin-left: rem-base-50(5px);
					font-size: rem-base-50(12px);
					line-height: rem-base-50(14px);
					color: rgb(114, 118, 142);
					font-family: SFProText-Regular;
					width: rem-base-50(142px);
					flex: 1;
					overflow: hidden; /*超出部分隐藏*/
					white-space: nowrap; /*不换行*/
					text-overflow: ellipsis; /*超出部分文字以...显示*/
				}
			}
			.apply-job {
				margin-left: rem-base-50(13px);
				margin-right: rem-base-50(15px);
				.button {
					border: 0;
					width: rem-base-50(110px);
					height: rem-base-50(32px);
					border-radius: rem-base-50(2px);
					font-size: rem-base-50(14px);
					background-color: #168cd8 !important;
					color: #fff;
					float: right;
					font-family: SFProText-Bold;
					padding: 0 !important;
					cursor: pointer;

					&.is-applied {
						background-color: #f2f2f2;
						color: rgba(50, 60, 80, 0.5);
					}
				}
			}
		}
	}
}
</style>
